<template>
  <b-navbar class="nav-under-table border-top" variant="light" data-test-path="footer" v-if="notInTab" >
  <b-container class="p-0 m-0 w-100" fluid="true" ref="navbar">
    <b-row>
      <b-col cols="auto" v-if="slotEnable">
        <div style="position:relative; width: 0px; height: 0px">
          <div style="position:absolute;">
            <slot name="info"></slot>
          </div>
        </div>
      </b-col>
      <b-col></b-col>
      <b-col cols="auto">
        <b-container class="p-0" fluid="true">
          <b-row class="justify-content-center">
            <slot></slot>
          </b-row>
        </b-container>
      </b-col>
      <b-col></b-col>
    </b-row>

  </b-container>
  </b-navbar>
</template>

<script>

import {isInTab} from "@/activity/templates/layouts/tabs/TabUtils";

export default {
  name: "FooterNavbar",
  components: {},
  methods: {

  },
  mounted() {
    if(this.$scopedSlots["info"]){
      this.slotEnable = true;
    }
    this.notInTab = !isInTab(this.$el);
  },

  data: () => ({
    notInTab: false,
    slotEnable: false
  }),

}
</script>
